module.exports = __webpack_public_path__ + "7d1cc7eb2c5b217ec940a211c520871b.pdf";